import { supabase } from './supabase';

/** Incomplete comms chip linked to a fulfillment task. */
export type IncompleteChip = {
  cardId: string;
  cardName: string;
};

/**
 * Incomplete = comms_task_links.completed_at IS NULL.
 * Ticked cards do not appear in the Spec Queue picker.
 */
export async function fetchIncompleteChips(taskId: string): Promise<IncompleteChip[]> {
  const { data: links, error: linksError } = await supabase
    .from('comms_task_links')
    .select('card_id, completed_at')
    .eq('task_id', taskId)
    .is('completed_at', null);

  if (linksError) throw linksError;

  const cardIds = ((links as Array<{ card_id: string }> | null) ?? []).map((l) => l.card_id);
  if (cardIds.length === 0) return [];

  const { data: items, error: itemsError } = await supabase
    .from('comms_items')
    .select('card_id, card_name, occurred_at')
    .in('card_id', cardIds)
    .order('occurred_at', { ascending: false });

  if (itemsError) throw itemsError;

  const names = new Map<string, string>();
  for (const item of (items as Array<{ card_id: string; card_name: string }> | null) ?? []) {
    if (!names.has(item.card_id)) names.set(item.card_id, item.card_name);
  }

  return cardIds.map((cardId) => ({
    cardId,
    cardName: names.get(cardId) || cardId,
  }));
}
